import { api } from './client'

/** Contratti per operatore sul mese gara (api/reports/operator-monthly-contracts). Solo conteggi, righe filtrate per visibilita'. */
export interface OperatorMonthlyBuckets {
  total: number
  activated: number
  inProgress: number
  rejected: number
  storno: number
}

export interface OperatorMonthlyItem {
  operatorId: number
  operatorName: string
  monthStartDay: number
  from: string
  to: string
  current: OperatorMonthlyBuckets
  previous: OperatorMonthlyBuckets
  delta: number
}

export interface OperatorMonthly {
  year: number
  month: number
  items: OperatorMonthlyItem[]
}

export const fetchOperatorMonthly = (year: number, month: number): Promise<OperatorMonthly> =>
  api<OperatorMonthly>(`/api/reports/operator-monthly-contracts?year=${year}&month=${month}`)
